import Hero from "../components/Hero";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import ConditionsGrid from "../components/ConditionsGrid";
import PracticeAreas from "../components/PracticeAreas";
import WhyChooseUs from "../components/WhyChooseUs";
import BlogPreview from "../components/BlogPreview";
import CtaBand from "../components/CtaBand";

/* Order: hero -> about -> testimonials -> conditions -> services ->
   approach -> blogs -> CTA. About no longer has its own route — it
   lives here now. Testimonials and BlogPreview self-hide while their
   data is empty. */
export default function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Testimonials />
      <ConditionsGrid />
      <PracticeAreas />
      <WhyChooseUs />
      <BlogPreview />
      <CtaBand />
    </>
  );
}
